import React from "react";
import doctor1 from "../../image/doctor1.jpg";
import doctor2 from "../../image/doctor2.jpg";
import doctor3 from "../../image/doctor3.jpg";
import doctor4 from "../../image/doctor4.jpg";
import doctor5 from "../../image/doctor5.jpg";
import doctor6 from "../../image/doctor6.jpg";
import doctor7 from "../../image/doctor7.jpg";
import Doctor from "./Doctor";
const Doctors = () => {
  const doctors = [
    {
      img: doctor1,
      name: "dr. Anam",
    },
    {
      img: doctor2,
      name: "dr. Rofiq",
    },
    {
      img: doctor3,
      name: "dr. khayer",
    },
    {
      img: doctor4,
      name: "dr. Any",
    },
    {
      img: doctor5,
      name: "dr. Nazmul",
    },
    {
      img: doctor6,
      name: "dr. Basar",
    },
    {
      img: doctor7,
      name: "dr. lucy",
    },
  ];
  return (
    <>
      <div>
        <h1 className="text-center my-4">Oure Doctors</h1>
        <div className="container row">
          {doctors.map((doctor) => (
            <Doctor doctor={doctor}></Doctor>
          ))}
        </div>
      </div>
    </>
  );
};

export default Doctors;
